import * as bootstrap from 'bootstrap';
import {CreatePopper} from '@popperjs/core'

export default {
  name: "App",
  props: ["wa", "fb", "button"],
  data: function () {
    return {
      buttonColor: "#129bf4",
      buttonText: "Ayuda",
      whatsappFullUrl: "",
      messengerFullUrl: "",
      whatsappClient: "",
      messengerClient: "",
      whatsappText: "Hola, requiero más información",
      messengerText: "Hola, requiero más información",
      whatsappLabel: "Whatsapp",
      messengerLabel: "Messenger",
      totalChannels: 0,
      totalParams: 3,
      active: false,
      tooltipList: []
    };
  },
  mounted: function(){
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    
    this.tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl, {placement: 'right', trigger: 'hover'})
    });
  },
  created: function () {
    
    this.totalChannels = 0;

    this.whatsappFullUrl = "";
    this.messengerFullUrl = "";

    const whatsappBaseUrl = "https://wa.me/";
    const messengerBaseUrl = "http://m.me/";

    if (this.wa) {
      this.processWhatsapp();
      this.totalChannels++;
    }

    if (this.fb) {
      this.processMessenger();
      this.totalChannels++;
    }

    if (this.button) {
      this.processButton();
    }

    this.whatsappFullUrl =
      this.whatsappClient !== ""
        ? encodeURI(
          `${whatsappBaseUrl}${this.whatsappClient}?text=${this.whatsappText}`
        )
        : "";
    this.messengerFullUrl =
      this.messengerClient !== ""
        ? encodeURI(
          `${messengerBaseUrl}${this.messengerClient}?text=${this.messengerText}`
        )
        : "";

    this.totalChannels > 1 ? (this.active = false) : (this.active = true);
  },
  methods: {
    processButton() {
      const splittedButton = this.button.trim().split(':');
      splittedButton[0] !== '' ? this.buttonColor = splittedButton[0] : null;
      splittedButton[1] !== '' ? this.buttonText = splittedButton[1] : null;
    },
    openLink(link) {
      window.open(link);
    },
    toggle() {
      this.active = !this.active;
    },
    processWhatsapp() {
      const splittedWhatsapp = this.wa.trim().split(":");

      const verifiedString = this.verifyString(splittedWhatsapp);

      verifiedString[0] !== ""
        ? (this.whatsappClient = verifiedString[0])
        : null;
      verifiedString[1] !== "" ? (this.whatsappLabel = verifiedString[1]) : null;
      verifiedString[2] !== ""
        ? (this.whatsappText = verifiedString[2])
        : null;
    },
    processMessenger() {
      const splittedMessenger = this.fb.trim().split(":");

      const verifiedString = this.verifyString(splittedMessenger);

      verifiedString[0] !== ""
        ? (this.messengerClient = verifiedString[0])
        : null;
      verifiedString[1] !== ""
        ? (this.messengerLabel = verifiedString[1])
        : null;
      verifiedString[2] !== ""
        ? (this.messengerText = verifiedString[2])
        : null;
    },
    verifyString(splittedString) {
      if (splittedString.length > this.totalParams) {
        const formattedString = [];

        formattedString.push(splittedString[0]);
        formattedString.push(
          splittedString[1]
        );
        formattedString.push(splittedString.slice(2, splittedString.length).join(":"));

        return formattedString;
      } else {
        return splittedString;
      }
    },
  },
};